import gql from "graphql-tag";

export const GET_SUBUNIT = gql`
  query subUnit($id: ID!) {
    subUnit(id: $id) {
      id
      organizationNumber
      name
      department {
        id
        name
      }
    }
  },
`;
